/* eslint-disable @typescript-eslint/explicit-module-boundary-types */

import { useGlobal } from '@/store'
import config from '@/config'

const HOSTNAME_VARIABLE = 'eyedoclocator'
const KBYG_VARIABLE = 'member'
const BPP_HOSTNAME_VARIABLE = 'bpp'
const CLIENT_ID_VARIABLE = '$CLIENT_ID'
const LOCALE_VARIABLE = '$LOCALE'
const ENCRYPTED_PARAM_BPP_VARIABLE = '$EncryptedParamBPP'

export default class BottomSummaryPPLink {
  private json: any
  public readonly title: string;
  public readonly href: string;

  constructor (json: any) {
    this.json = json || {}
    this.title = this.json.title
    this.href = this.formatUrl(this.json.href || '')
  }

  static of (json: any): BottomSummaryPPLink {
    return new BottomSummaryPPLink(json)
  }

  private formatUrl (url: string): string {
    if (url.startsWith(HOSTNAME_VARIABLE)) {
      return this.formatProviderLocatorUrl(url)
    }

    if (url.startsWith(KBYG_VARIABLE)) {
      return this.formatKbygUrl(url)
    }

    return url
  }

  private formatKbygUrl (url: string): string {
    const global = useGlobal()
    const kbygVariable = url.split('/')[0]

    return url
      .replace(kbygVariable, this.getKbygHost(kbygVariable))
      .replace(CLIENT_ID_VARIABLE, global.clientId)
      .replace(LOCALE_VARIABLE, global.locale || '')
  }

  private getKbygHost (kbygVariable: string): string {
    const HOSTNAME = window.location.origin
    return HOSTNAME.replace(BPP_HOSTNAME_VARIABLE, kbygVariable)
  }

  private formatProviderLocatorUrl (url: string): string {
    const global = useGlobal()
    const hostUrl = this.getProviderLocatorHost(url)

    url = url
      .replace(HOSTNAME_VARIABLE, hostUrl)
      .replace(CLIENT_ID_VARIABLE, global.clientId)
      .replace(LOCALE_VARIABLE, global.locale)

    if (!url.includes(ENCRYPTED_PARAM_BPP_VARIABLE)) {
      return url
    }

    return global.encryptedURL
      ? url.replace(ENCRYPTED_PARAM_BPP_VARIABLE, this.getEncryptedParam())
      : this.removeQueryParamWithValue(url, ENCRYPTED_PARAM_BPP_VARIABLE)
  }

  private getProviderLocatorHost (url: string): string {
    const HOSTNAME = window.location.origin
    const locatorName = url.split('/')[0]

    if (HOSTNAME.includes('kbyg') || HOSTNAME.includes('member') || HOSTNAME.includes('bpp')) {
      return HOSTNAME.replace(/member|kbyg|bpp/g, locatorName)
    }

    const isTestContentLocation = config.TEST_HOSTS.some(host => HOSTNAME.includes(host))
    return isTestContentLocation
      ? `https://${HOSTNAME_VARIABLE}ashuat.eyemedvisioncare.com`
      : `https://${HOSTNAME_VARIABLE}.eyemedvisioncare.com`
  }

  private removeQueryParamWithValue (url: string, value: string): string {
    const [baseUrl, queryString] = url.split('?')

    if (!queryString) {
      return url
    }

    const queryParams = queryString
      .split('&')
      .filter(param => !param.includes(value))

    return queryParams.length ? `${baseUrl}?${queryParams.join('&')}` : baseUrl
  }

  private getEncryptedParam (): string {
    const global = useGlobal()
    return (global.encryptedURL || '').replace(/ /g, '+')
  }
}
